import React, { useState } from 'react';
import { Card, Row, Col, Space, Collapse, Tag, Table, Radio } from 'antd';
import { PROCESSING_FEE_TYPE } from '../../common/constants';

// 国际运费计算参数
function ForwardingFee(props: any) {
    const { cart, forwardingFeeDetails } = props || {};
    const { forwardingFeeRecords, items } = cart?.groups?.[0] || {};
    const [type, setType] = useState('USER');
    let data = {};
    forwardingFeeRecords?.forwardingFeeRecords?.forEach(item => {
        let current = item;
        if(item?.forwardingFeeType === 'USER' && forwardingFeeDetails) {
            current = forwardingFeeDetails;
        }
        data[current?.forwardingFeeType] = {
            ...current,
            cType: forwardingFeeRecords?.cType,
            skuRecords: current?.skuRecords?.map(sku => {
                const id = sku?.orderItemId;
                const orderItem = items?.find(orderItem => orderItem?.id === id);
                return {
                    ...sku,
                    thumbnail: orderItem?.sku?.images?.[0]?.full?.url
                }
            })
        };
    })
    const renderPrice = (text?)=> {
        return  <div>{ text/100 }</div>
    }
    const columns1: any = [{
        title: <div style={{wordBreak: 'break-all'}}>运费分类<br />cType</div>,
        dataIndex: 'cType',
        key: 'cType',
        align: 'center',
        render: (text) => <div style={{width: '80px'}}>{text}</div>
    }, {
        title: <div style={{wordBreak: 'break-all'}}>计费重量单位<br />unitPriceWeightUnit</div>,
        dataIndex: 'unitPriceWeightUnit',
        key: 'unitPriceWeightUnit',
        align: 'center',
        render: (text) => <div>{text || 'LB'}</div>
    }, {
        title: <div style={{wordBreak: 'break-all'}}>首重价格<br />firstUnitPrice</div>,
        dataIndex: 'firstUnitPrice',
        key: 'firstUnitPrice',
        align: 'center',
        render: (text, record) => <div>{text/100 || record.firstPoundPrice/100 }</div>
    }, {
        title: <div style={{wordBreak: 'break-all'}}>续重价格<br />pricePerUnit</div>,
        dataIndex: 'pricePerUnit',
        key: 'pricePerUnit',
        align: 'center',
        render: (text, record) => <div>{text/100 || record.pricePerPound/100}</div>
    }, {
        title: <div style={{wordBreak: 'break-all'}}>商品总重(lb)<br />itemsTotalWeight(lb)</div>,
        dataIndex: 'itemsTotalWeight',
        key: 'itemsTotalWeight',
        align: 'center'
    }, {
        title: <div style={{wordBreak: 'break-all'}}>外箱重(lb)<br />packageWeight(lb)</div>,
        dataIndex: 'packageWeight',
        key: 'packageWeight',
        align: 'center'
    }, {
        title: <div style={{wordBreak: 'break-all'}}>总重量(lb)<br />totalWeight(lb)</div>,
        dataIndex: 'totalWeight',
        key: 'totalWeight',
        align: 'center'
    }, {
        title: <div style={{wordBreak: 'break-all'}}>记重运费<br />forwardingFinalCost</div>,
        dataIndex: 'forwardingFinalCost',
        key: 'forwardingFinalCost',
        align: 'center',
        render: (text) => renderPrice(text)
    },, {
        title: <div style={{wordBreak: 'break-all'}}>物流手续费<br />serviceFee</div>,
        dataIndex: 'serviceFee',
        key: 'serviceFee',
        align: 'center',
        render: (text) => renderPrice(text)
    }, {
        title: <div style={{wordBreak: 'break-all'}}>物流渠道手续费<br />cbPartnerServiceFee</div>,
        dataIndex: 'cbPartnerServiceFee',
        key: 'cbPartnerServiceFee',
        align: 'center',
        render: (text) => renderPrice(text)
    }, {
        title: <div style={{wordBreak: 'break-all'}}>拆包手续费<br />unpackingFee</div>,
        dataIndex: 'unpackingFee',
        key: 'unpackingFee',
        align: 'center',
        render: (text) => <div>{ !isNaN(text) ? text/100 : text }</div>
    }, {
        title: <div style={{wordBreak: 'break-all'}}>商家额外费用<br />merchantAdditionalFee</div>,
        dataIndex: 'merchantAdditionalFee',
        key: 'merchantAdditionalFee',
        align: 'center',
        render: (text) => <div>{ !isNaN(text) ? text/100 : text }</div>
    }, {
        title: <div style={{wordBreak: 'break-all'}}>VAT服务费<br />vatServiceFee</div>,
        dataIndex: 'vatServiceFee',
        key: 'vatServiceFee',
        align: 'center',
        render: (text) => <div>{ !isNaN(text) ? text/100 : text }</div>
    }, {
        title: <div style={{wordBreak: 'break-all'}}>最终运费<br />finalCost</div>,
        dataIndex: 'finalCost',
        key: 'finalCost',
        align: 'center',
        render: (text) => renderPrice(text)
    }];

    const columns2: any = [{
        title: <div style={{wordBreak: 'break-all'}}>截图<br />Thumbnail</div>,
        dataIndex: 'thumbnail',
        key: 'thumbnail',
        align: 'center',
        render: (record) => <img style={{width: '100px'}} src={record} />
    }, {
        title: <div>ItemId</div>,
        dataIndex: 'orderItemId',
        key: 'orderItemId',
        align: 'center',
        width: '10%'
    }, {
        title: <div style={{wordBreak: 'break-all'}}>重量来源<br />weightSource</div>,
        dataIndex: 'weightSource',
        key: 'weightSource',
        align: 'center',
    }, {
        title: <div style={{wordBreak: 'break-all'}}>重量系数<br />weightCoefficient</div>,
        dataIndex: 'weightCoefficient',
        key: 'weightCoefficient',
        align: 'center',
        render: (record) => <div style={{width: '80px'}}>{record}</div>
    }, {
        title: <div style={{wordBreak: 'break-all'}}>商品原始重量(lb)<br />originalWeight(lb)</div>,
        dataIndex: 'originalWeight',
        key: 'originalWeight',
        align: 'center',
    }, {
        title: <div style={{wordBreak: 'break-all'}}>计费重量(lb)<br />netWeight(lb)</div>,
        dataIndex: 'netWeight',
        key: 'netWeight',
        align: 'center',
    }, {
        title: <div style={{wordBreak: 'break-all'}}>税前金额<br />declaredValue</div>,
        dataIndex: 'declaredValue',
        key: 'declaredValue',
        align: 'center',
        render: (text) =>renderPrice(text)
    }, {
        title: <div style={{wordBreak: 'break-all'}}>税金比例<br />dutyRate</div>,
        dataIndex: 'dutyRate',
        key: 'dutyRate',
        align: 'center'
    }, {
        title: <div style={{wordBreak: 'break-all'}}>税金<br />dutyCost</div>,
        dataIndex: 'dutyCost',
        key: 'dutyCost',
        align: 'center',
        render: (text) => renderPrice(text)
    }];

    function handleTypeChange(v) {
        setType(v?.target?.value);
    }

    if(!forwardingFeeRecords) return null;
    return <Card title="国际运费计算参数" style={{ width: '100%' }}>
        <Space direction="vertical" size='middle' style={{ maxWidth: '100%' }}>
            <div>
                注:<br />
                - 最终运费 = 首磅 + 续磅 * INT(总重量 - 1) + 物流手续费（这里的物流手续费加在运费里，和上面的服务费不同）<br />
                - 便捷直邮的预收关税是按照实付金额（含运费折扣等的税前金额）乘以税金比例算出来的
            </div>
            <Radio.Group defaultValue="USER" buttonStyle="solid" onChange={handleTypeChange}>
                <Radio.Button value="USER">USER</Radio.Button>
                <Radio.Button value="ESTIMATED">ESTIMATED</Radio.Button>
                <Radio.Button value="TEST">TEST</Radio.Button>
            </Radio.Group>
            <Table
                dataSource={data[type] ? [data[type]] : []}
                columns={columns1}
                pagination={false}
            />
            <Table
                dataSource={data[type]?.skuRecords ? data[type]?.skuRecords : []}
                columns={columns2}
                pagination={false}
            />
        </Space>
    </Card>
}

export default ForwardingFee;